module.exports = __webpack_public_path__ + "static/sophomore-2-ad01640aed3a7330fac87904821fde39.jpg";